export default function validString(variable) {
    if (variable === null || variable === undefined) {
        return false;
    }
    variable = variable.toString().trim();

	return variable.length !== 0;
}

export function removeHTMLtags(variable) {
    if(variable === null) {
        return '';
    }
    const regex = /(<([^>]+)>)/ig;
    variable = variable.replace('&nbsp;', '');
    return variable.replace(regex, '');
}
